import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import 'react-dropdown-tree-select/dist/styles.css';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { handleErrors } from "common.js";
import { CircularProgress, Backdrop } from "@mui/material";
import { CATEGORY } from "constants.js";
import MDTypography from "components/MDTypography/index.js";

function AddCategory(props) {
  const type = props.props.type;
  const navigate = useNavigate();
  const convertToTree = (data) => {
    let x = [];
    const treeData = [];
    data.forEach((node) => {
      if (node.children.length == 0) {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        treeData.push(tempArrayNew);
      }
      else {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        tempArrayNew.children = convertToTree(node.children);
        treeData.push(tempArrayNew);
      }
    });
    return treeData;
  };

  const { id } = useParams();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [categoryData, setCategoryData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    data.type = type;
    axios({
      // Endpoint to send files
      url: BASE + "api/category/create",
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate((type == CATEGORY.PRODUCT) ? '/productCategory/list' : (type == CATEGORY.SERVICE) ? '/serviceCategory/list' : null);
          }, 3000);
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == CATEGORY.PRODUCT) ? t('add product category') : (type == CATEGORY.SERVICE) ? t('add service category') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={2} pb={2} >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Card>
              {(categoryData) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={5}>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('categoryName')} <i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="name" label="" {...register("name", { required: true })} fullWidth />
                        {errors.name && errors.name.type === "required" && (
                          <p className="errorMsg">{t('Name is mandatory')}</p>
                        )}
                        {errors.name && (
                          <p className="errorMsg">{t(errors.name.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography component="span" className="categoryNoteIcon"># </MDTypography>
                        <label className="labelCls">{t('handle')}<i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="handle" label="" {...register("handle", { required: true })} fullWidth />
                        {errors.handle && errors.handle.type === "required" && (
                          <p className="errorMsg">{t('handleRequired')}</p>
                        )}
                        {errors.handle && (
                          <p className="errorMsg">{t(errors.handle.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography component="span" className="categoryNoteIcon">## </MDTypography>
                        <label className="labelCls">{t('tag name')}</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="tagName" label="" {...register("tagName")} fullWidth />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t('Add')}</MDButton>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} className="categoryNote">
                        <MDTypography component="span" className="categoryNoteIcon"># </MDTypography>
                        <MDTypography component="span" variant="caption" className="shopifyHandleNote">{t('shopifyHandleNote')}</MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} className="categoryNote">
                        <MDTypography component="span" className="categoryNoteIcon">## </MDTypography>
                        <MDTypography component="span" variant="caption" className="shopifyHandleNote"> {t('tagNameNote')}</MDTypography>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
                : null}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddCategory;
